import { observable } from 'mobx';
import { IValue, ValueEntity } from './BasicEntities';

export interface ISkuSkin {
    type: IValue[];
    tone: IValue[];
}

class Type extends ValueEntity {}
class Tone extends ValueEntity {}

export class SkuSkin {
    @observable public type: Type[] = [];
    @observable public tone: Tone[] = [];

    public static fromJson(skin: ISkuSkin): SkuSkin {
        const newSkin = new SkuSkin();
        if (!skin) {
            return newSkin;
        }

        newSkin.type = skin.type
            ? skin.type.map(data => {
                  return Type.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        newSkin.tone = skin.tone
            ? skin.tone.map(data => {
                  return Tone.fromJson({
                      key: data.key ? data.key.trim() : '',
                      value: data.value && data.value.trim()
                  });
              })
            : [];

        return newSkin;
    }

    public toJSON(): ISkuSkin {
        return {
            type: this.type,
            tone: this.tone
        };
    }
}
